import _ from 'underscore';
import { sendToDatadog, attachAudioPresenterSources } from '@shoflo/polymer';
import { getProgramLayers, selectSceneLayout } from '@studio/program';
import {
  logProgramChange,
  getBroadcastSourcesFromLayers
} from '@shoflo/studio-redux/utils';
import setProgram from 'actions/program/setProgram';
import {
  cancelDisconnectSource,
  setSceneLayout
} from '@shoflo/studio-redux/actions';
import { BROADCAST_DISCONNECT_SOURCE } from 'actions/Types';
import { deleteSource } from 'actions/source';
import { sceneBuilder } from '@studio/program';

function disconnectSource(sourceId) {
  return (dispatch, getState) => {
    const {
      sceneLayout,
      sceneLayers,
      banners,
      attendeeMuteStatus,
      broadcastSources,
      program,
      brandingSettings
    } = getState();

    const layers = getProgramLayers(program);

    // Get disconnected source
    const [source] = broadcastSources.sources.filter(bs => bs._id === sourceId);

    // remove source tile after 120sec
    const timeoutId = setTimeout(() => {
      dispatch(deleteSource(sourceId));
      dispatch(cancelDisconnectSource(sourceId));
      // Possibly need to handle dismiss attendee to prevent attendee from sticking around

      const logMessage = `Disconnected and deleted sourceId: ${sourceId}`;

      sendToDatadog('Source', { source }, logMessage, false);
    }, 120 * 1000);

    // Get layer source
    const [layerSource] = layers?.filter(
      layer => layer?.source._id === sourceId
    );
    // If disconnected source exist in program, rebuild scene
    if (!!layerSource) {
      const sourcesInProgram = getBroadcastSourcesFromLayers(
        layers,
        broadcastSources?.sources
      );

      const nextSceneLayout = selectSceneLayout(
        sceneLayout,
        layerSource.source,
        sourcesInProgram
      );

      const combinedLayers = [...sceneLayers, ...banners];

      const sources = layers
        .map(layer => layer.source)
        // Need to make sure the source is in the broadcastSources array, otherwise we'd include overlays or other source here
        .filter(source =>
          _.find(broadcastSources.sources, bs => bs._id === source._id)
        )
        .filter(source => source._id !== sourceId);

      const withAudioPresenterSources = attachAudioPresenterSources(
        sources,
        attendeeMuteStatus
      );

      const scene = sceneBuilder(
        nextSceneLayout,
        withAudioPresenterSources,
        combinedLayers,
        {},
        {},
        brandingSettings?.fonts
      );

      dispatch(setProgram(scene));
      logProgramChange(getState, 'disconnectSource action');

      if (!_.isEqual(sceneLayout, nextSceneLayout)) {
        dispatch(setSceneLayout(nextSceneLayout));
      }
    }

    const action = {
      type: BROADCAST_DISCONNECT_SOURCE,
      payload: { sourceId, timeoutId }
    };

    dispatch(action);
  };
}

export default disconnectSource;
